const prismJS = require('prismjs');

const components = require('prismjs/components');
const getLoader = require('prismjs/dependencies');

( function (a) {

    const componentsToLoad = [ 'php' ];

    const $highlights = a('code[class*="language-"]');

    if ($highlights.length > 0) {
        const loader = getLoader(components, componentsToLoad, []);

        loader.load(id => {
            console.log(id);
            require(`prismjs/components/prism-${id}.min.js`);
        });

        prismJS.highlightAll();
    }
})(jQuery);
